<template>
  <Success>
    <Thanks :email="email" :title="title">
      <view-account v-if="isTrial2Paid" />
      <zm-button
        v-else
        data-testid="checkout-button-zp-aic-get-started"
        :data-url="targetUrl"
        size="lg"
        type="primary"
        @click="goToGetStarted"
      >
        {{ $t('billing.success.get_started') }}
      </zm-button>
    </Thanks>
  </Success>
</template>

<script>
import Success from '@/views/succezz/facade.vue';
import Thanks from '@/views/succezz/thanks-template';
import ViewAccount from '@/views/succezz/thanks-template/view-account.vue';
import commonMixin from '@/views/succezz/mixin/common';
import { translateToEn } from '@/plugins/i18n';
import { navigateToTargetPage } from '@/utils/modal-utils.js';
import { generateGAbizInfo } from '@/views/checkout/utils';
import { getEmailCTAsTrackingUrl, UTM_CONTENT_CODE } from '@/views/succezz/utils/email-ctas-tracking';
import { flowTypes, pageConfig } from '@/common/service/page-config';

const SUCCESS_REDIRECT_PATH = '/ai-studio/virtual-agent/ai-receptionist';

export default {
  name: 'ZoomPhoneAiConciergeSuccess',
  components: { Success, Thanks, ViewAccount },
  mixins: [commonMixin],
  computed: {
    isTrial2Paid() {
      return pageConfig?.type === flowTypes.trial2paid;
    },
    targetUrl() {
      return getEmailCTAsTrackingUrl(SUCCESS_REDIRECT_PATH, { utmContent: UTM_CONTENT_CODE.getStarted });
    },
  },
  methods: {
    goToGetStarted() {
      this.$tracking.buyInteractionWithBizInfo(
        'purchase confirmation',
        translateToEn('billing.success.get_started'),
        ...generateGAbizInfo(),
      );
      navigateToTargetPage(SUCCESS_REDIRECT_PATH);
    },
  },
};
</script>
